// Central editable configuration for Prospera Staffing.
// Edit statistics, contact details, and content here — no code changes needed elsewhere.

export const STATS = [
  { value: 10, suffix: "+", label: "Industry Sectors" },
  { value: 1000, suffix: "+", label: "Talent Connections" },
  { value: 50, suffix: "+", label: "Recruitment Categories" },
  { value: 24, suffix: "/7", label: "Client Support" },
];

export const CONTACT_DETAILS = {
  company: "PROSPERA STAFFING SOLUTIONS - FZCO",
  location:
    "38th Floor, Media One Hotel - Office Tower, Dubai Media City, PO Box 334069, Dubai, United Arab Emirates.",
  phone: "+971 4 228 52 85",
  hours: "Sun–Thu, 9:00 AM – 6:00 PM (GST)",
  email: "info@prosperastaffing.com",
  emailNote: "Replies within 24 hours on business days",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3613.0!2d55.1574!3d25.0951!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6b4e8c0f0f0f%3A0x0!2sMedia%20One%20Hotel%20Dubai%20Media%20City!5e0!3m2!1sen!2sae!4v1700000000000",
};

export const HERO_SLIDES = [
  {
    image: "https://images.pexels.com/photos/162031/dubai-tower-arab-khalifa-162031.jpeg",
    label: "Workforce Solutions",
    headline: ["Scaling Teams", "Across the", "Emirates."],
    text: "Contract, offshore, and specialist hiring — flexible workforce solutions built around how your organization actually grows.",
  },
  {
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
    label: "Talent, Delivered",
    headline: ["The Right People,", "In the Right", "Roles."],
    text: "From permanent placements to executive search, we help you find professionals who create measurable, lasting impact for your business.",
  },
  {
    image: "https://images.unsplash.com/photo-1518684079-3c830dcef090",
    label: "Dubai & the GCC",
    headline: ["Building Teams", "That Move", "Business Forward."],
    text: "Prospera Staffing connects ambitious organizations with exceptional professionals — workforce solutions designed for growth, agility, and long-term success across Dubai and the GCC.",
  },
];

export const INSIGHTS = [
  {
    category: "Hiring Trends",
    title: "What GCC Employers Look For in 2026",
    excerpt: "The skills, expectations, and hiring signals shaping recruitment across Dubai and the wider Gulf this year.",
    date: "Jan 2026",
  },
  {
    category: "Talent Strategy",
    title: "Building Resilient Teams in a Fast-Moving Market",
    excerpt: "How agile workforce planning helps organizations stay ahead when business needs shift quickly.",
    date: "Dec 2025",
  },
  {
    category: "Executive Search",
    title: "Hiring Senior Leaders: A Considered Approach",
    excerpt: "Why confidential, structured executive search delivers better long-term leadership outcomes.",
    date: "Nov 2025",
  },
  {
    category: "Candidate Advice",
    title: "Standing Out as a Professional in the UAE",
    excerpt: "Practical guidance for job seekers looking to make their next move count in a competitive market.",
    date: "Oct 2025",
  },
];

export const SOCIALS = {
  linkedin: "https://linkedin.com",
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
};

export const SERVICES = [
  {
    id: "permanent-recruitment",
    icon: "UserCheck",
    title: "Permanent Recruitment",
    desc: "Helping businesses find professionals for long-term roles and critical positions.",
  },
  {
    id: "contract-temporary",
    icon: "CalendarClock",
    title: "Contract & Temporary Staffing",
    desc: "Flexible workforce solutions for project-based, seasonal, and short-term requirements.",
  },
  {
    id: "executive-search",
    icon: "Crown",
    title: "Executive Search",
    desc: "Confidential and focused search for senior leaders and specialist professionals.",
  },
  {
    id: "staff-augmentation",
    icon: "Users",
    title: "Staff Augmentation",
    desc: "Quickly strengthen your team with skilled professionals for specific business needs.",
  },
  {
    id: "remote-offshore",
    icon: "Globe2",
    title: "Remote & Offshore Staffing",
    desc: "Connect with qualified talent beyond traditional geographical boundaries.",
  },
  {
    id: "rpo-support",
    icon: "Workflow",
    title: "Recruitment Process Support",
    desc: "Flexible recruitment support to improve speed, reach, and hiring efficiency.",
  },
  {
    id: "hr-consulting",
    icon: "ClipboardList",
    title: "HR & Workforce Consulting",
    desc: "Practical workforce guidance to help organizations structure and scale their teams.",
  },
  {
    id: "specialized-talent",
    icon: "Target",
    title: "Specialized Talent Acquisition",
    desc: "Focused recruitment across technology, finance, engineering, healthcare, and more.",
  },
];

export const WHY_FEATURES = [
  {
    icon: "Briefcase",
    title: "Business-Focused Approach",
    desc: "We align every search with your commercial goals, not just a job description.",
  },
  {
    icon: "ShieldCheck",
    title: "Quality-Driven Candidate Search",
    desc: "Rigorous screening ensures every shortlist is genuinely relevant and dependable.",
  },
  {
    icon: "Layers",
    title: "Sector Knowledge",
    desc: "Deep familiarity with the industries and roles that matter across the GCC.",
  },
  {
    icon: "Zap",
    title: "Faster Hiring Support",
    desc: "Streamlined processes that shorten time-to-hire without compromising fit.",
  },
  {
    icon: "Handshake",
    title: "Long-Term Partnership",
    desc: "We invest in relationships that grow with your organization year after year.",
  },
];

export const PROCESS = [
  { no: "01", title: "Understand", desc: "We learn about your business, goals, culture, and workforce requirements." },
  { no: "02", title: "Identify", desc: "We search and identify professionals aligned with the role and your organization." },
  { no: "03", title: "Evaluate", desc: "We assess experience, skills, suitability, and professional fit." },
  { no: "04", title: "Connect", desc: "We help move the right people and the right opportunities forward." },
];

export const INDUSTRIES = [
  { icon: "Cpu", name: "Information Technology", desc: "Engineers, developers, and digital specialists." },
  { icon: "Landmark", name: "Banking & Financial Services", desc: "Finance, risk, and compliance professionals." },
  { icon: "HardHat", name: "Engineering & Construction", desc: "Project, site, and technical leadership." },
  { icon: "Stethoscope", name: "Healthcare", desc: "Clinical, allied health, and administration." },
  { icon: "ConciergeBell", name: "Hospitality", desc: "Front-of-house, culinary, and operations." },
  { icon: "ShoppingBag", name: "Retail & Consumer", desc: "Store, category, and brand talent." },
  { icon: "Truck", name: "Logistics & Supply Chain", desc: "Operations, procurement, and distribution." },
  { icon: "TrendingUp", name: "Sales & Marketing", desc: "Revenue, growth, and brand builders." },
  { icon: "Building2", name: "Administration & Support", desc: "Office, HR, and business support roles." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Prospera understood our requirements quickly and helped us connect with professionals who genuinely matched our business needs.",
    name: "Layla Al Marri",
    title: "Head of Operations",
    company: "Meridian Group",
  },
  {
    quote:
      "The team's grasp of our sector was clear from day one. They delivered a shortlist that was relevant, considered, and ready to interview.",
    name: "Daniel Okafor",
    title: "Chief Technology Officer",
    company: "Northwind Digital",
  },
  {
    quote:
      "A genuinely consultative partner. Prospera moved fast without ever sacrificing the quality of the people they introduced to us.",
    name: "Aisha Rahman",
    title: "HR Director",
    company: "Gulf Horizon Holdings",
  },
];

export const LOCATIONS = [
  "Dubai",
  "Abu Dhabi",
  "Sharjah",
  "Ajman",
  "Ras Al Khaimah",
  "Wider GCC",
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "Employers", to: "/employers" },
  { label: "Job Seekers", to: "/job-seekers" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/36260020/pexels-photo-36260020.jpeg",
  gcc: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
  trust: "https://images.pexels.com/photos/7108269/pexels-photo-7108269.jpeg",
  employers: "https://images.pexels.com/photos/8463151/pexels-photo-8463151.jpeg",
  jobseekers: "https://images.pexels.com/photos/8068807/pexels-photo-8068807.jpeg",
};
